exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2l_qf5PlQxqu5FxF-tTHHV{font-size:14px;font-weight:400;font-weight:600;color:var(--neutralPrimary)}._2l_qf5PlQxqu5FxF-tTHHV._4mOfZKDGn7Mo8Gs4ZxC3Z{text-decoration:line-through}._1B02lPnjYfd9DVXy1f-IWd{height:14px;width:14px;min-width:14px;color:var(--neutralPrimary)}html[dir=ltr] ._1B02lPnjYfd9DVXy1f-IWd{margin-right:4px}html[dir=rtl] ._1B02lPnjYfd9DVXy1f-IWd{margin-left:4px}._1n-bWY-Fsl0YEKuDESNwse{font-size:12px;font-weight:400;color:var(--neutralSecondary)}._3wzUDH6RBuAdaF9u2bpg2k{font-size:12px;font-weight:400;color:var(--neutralPrimary)}", ""]);
// Exports
exports.locals = {
	"subject": "_2l_qf5PlQxqu5FxF-tTHHV",
	"isCancelled": "_4mOfZKDGn7Mo8Gs4ZxC3Z",
	"charm": "_1B02lPnjYfd9DVXy1f-IWd",
	"timeSecondaryText": "_1n-bWY-Fsl0YEKuDESNwse",
	"timePrimaryText": "_3wzUDH6RBuAdaF9u2bpg2k"
};